const CSUIDList = {
  artifacts: 'ast_artifacts',
  login: 'ast_login_page',
  ssoLogin: 'ast_ssologin',
  searchMember: 'ast_search_member_page',
  profile: 'ast_profile_tab',
  transactions: 'ast_transactions_tab',
  gifting: 'ast_gifting_tab',
  giftingHistory: 'ast_gifting_history_tab',
  query: 'ast_query_tab',
  queryPD: 'ast_personal_data_dialog',
  queryAlert: 'ast_all_fields_required_alert',
  queryTicketAlert: 'ast_wrong_ticket_n_alert',
  queryDashboard: 'ast_query_dashboard',
};

const CSEntriesMapped = [
  {name: CSUIDList.artifacts, refs: []},
  {name: CSUIDList.login, refs: []},
  {name: CSUIDList.ssoLogin, refs: []},
  {name: CSUIDList.searchMember, refs: []},
  {name: CSUIDList.profile, refs: []},
  {name: CSUIDList.transactions, refs: []},
  {name: CSUIDList.gifting, refs: []},
  {name: CSUIDList.giftingHistory, refs: []},
  {
    name: CSUIDList.query,
    refs: [
      'query_type',
      'query_type_select',
      'mapped_fields',
      'mapped_fields.reason',
      'mapped_fields.field',
    ],
  },
  {name: CSUIDList.queryPD, refs: []},
  {name: CSUIDList.queryAlert, refs: []},
  {name: CSUIDList.queryTicketAlert, refs: []},
  {name: CSUIDList.queryDashboard, refs: []},
];

export {CSUIDList, CSEntriesMapped};
